<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RgscT5/tc-custom/9780062337290.jpg?1716663320749" alt="This image is the cover for the book Believer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Believer
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An intricately plotted and brilliantly conceived stand-alone sequel to the international bestseller <i>The Swimmer</i> that turns the hottest political topics of our times into a complex, resonant thriller in the vein of John LeCarré.</b></p><p>Yasmine Ajam has fled her past in the rough Stockholm borough Bergort, reinventing herself as a trendspotter in New York City. One day she receives a startling message: there are riots erupting on the streets of Stockholm and they appear to be connected with the disappearance of her brother, Fadi.</p><p>Following rumors that Fadi was radicalized and died fighting for ISIS in Syria, Yasmine returns to Stockholm to discover what really happened to her brother. There she becomes entangled in a dangerous web of allegiances and violence that stretches far beyond the gangs on her childhood streets.</p><p>Meanwhile, in London, Klara Walldéen has landed a job at a human rights research institute working on a report to predict the effects of privatizing police forces. When Klara travels to Stockholm to present her findings to European Union policymakers, her laptop is stolen and one of her colleagues is pushed in front of an oncoming subway train. As her path collides with Yasmine’s, Klara begins to realize that she may unwittingly be contributing to the sinister agendas of powerful interests who will stop at nothing to attain their goals.</p><p>With <i>The Believer</i>, Joakim Zander delivers another "page-turning" (<i>Entertainment Weekly</i>) novel of suspense that is as sophisticated and timely as it is compelling.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joakim Zander
      </h2>
      
      <p class="authorDescription body article">Joakim Zander was born in Stockholm, has lived in Syria and Israel, and graduated from high school in the United States. He earned a PhD in law from Maastricht University in the Netherlands and has worked as a lawyer for the European Union in Brussels and Helsinki. Rights to his debut novel&#160;<I>The Swimmer</I>&#160;were sold in twenty-eight countries. Zander lives and works in southern Sweden with his family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cbe2e08